import "core-js/modules/es.array.reduce.js";
import { spacings } from '../theme/spacings';
import { breakpoints } from '../theme/breakpoints';
import { mediaBreakpointUp } from '../mixins/media-query';
var isNum = function isNum(n) {
  return !!((Number(n) || n === 0) && !isNaN(n));
};
var getNum = function getNum(n) {
  return isNum(n) ? Number(n) : null;
};
export var px = function px(n) {
  return isNum(n) ? "".concat(getNum(n), "px") : '';
};
export var percent = function percent(f) {
  return f && !isNaN(f) ? "".concat(f * 100, "%") : null;
};
var CSS_UNITS = ['em', 'rem', 'px', '%', 'ch', 'vh', 'vw'];
var spaceValueRegExp = /^([0-9]+)([a-zA-Z]+|%)$/i;
export var breakpointsStyles = function breakpointsStyles(breakpointsArray, styleFunc) {
  if (Array.isArray(breakpointsArray)) {
    return breakpointsArray.reduce(function (accumulator, breakpoint) {
      accumulator += mediaBreakpointUp(breakpoints[breakpoint], styleFunc(breakpoint));
      return accumulator;
    }, '');
  }
  return '';
};
export var getSpace = function getSpace(space) {
  if (!isNum(space)) {
    var matches = String(space).match(spaceValueRegExp);
    if (matches && matches.length >= 2) {
      var validValue = isNum(matches[1]);
      var validUnit = CSS_UNITS.includes(matches[2]);
      return validUnit && validValue ? space : '';
    }
    return '';
  }
  return space > spacings.length ? px(space) : px(spacings[space]);
};
export var getCssStyle = function getCssStyle(property, value) {
  return value ? "".concat(property, ":").concat(value, ";") : '';
};
export var margin = function margin(_ref) {
  var margin = _ref.margin;
  return getSpace(margin) && "margin: ".concat(getSpace(margin), ";");
};
export var padding = function padding(_ref2) {
  var padding = _ref2.padding;
  return getSpace(padding) && "padding: ".concat(getSpace(padding), ";");
};
export var bgcolor = function bgcolor(_ref3) {
  var bgcolor = _ref3.bgcolor;
  return bgcolor && "background-color: ".concat(bgcolor, ";");
};